// What a call placed FROM a complaint ticket is recorded as.
//
// One place, so the ticket table, the dashboard's SLA-breached list and the ticket
// drawer all log the same callType/sourceModule into callActivities (the
// Telecaller Workspace's stream) for the same ticket.

/** The call's purpose, from where the ticket stands. */
export const callTypeForTicket = (t = {}) => {
    const s = t?.status || '';
    if (s === 'refund_pending') return 'refund_followup';
    if (s === 'replacement_pending') return 'replacement_followup';
    if (s === 'courier_escalation') return 'courier_escalation';
    if (s === 'waiting_customer') return 'waiting_customer';
    if (s === 'doctor_review') return 'doctor_followup';
    return 'complaint_followup';
};

/** The module the call is attributed to: doctor cases are the doctor's desk. */
export const sourceModuleForTicket = (t = {}) =>
    (callTypeForTicket(t) === 'doctor_followup' ? 'doctor' : 'complaints');

/** The number to dial: the ticket's mobile, else its first alternate. '' when none. */
export const dialableMobile = (t = {}) => {
    const ok = (v) => String(v || '').replace(/\D/g, '').slice(-10);
    const first = ok(t?.mobile);
    if (first.length === 10) return first;
    const alt = ok(t?.alternateMobile);
    return alt.length === 10 ? alt : '';
};
